export const publicRoutes = [
  '/login',
  '/signup',
  '/sent-email',
  '/signup-email-sent',
  '/activate',
  '/resetpassword',
  '/success',
  '/activate-failed',
  '/forgot-password',
  '/verify-mfa',
  '/sso-activation',
  '/sso-signup',
  '/sso/:provider/callback',
  '/oidc',
  '/ai-test',
  '/payment-result',
];

// NOTE: the embedded Contract Checker (iframe inside SELISE Signature) is no
// longer a route in this SPA — it ships as its own HTML entry (`embed.html`)
// with its own router, so it never passes through ClientMiddleware here.
export const isPublicRoute = (pathname: string): boolean => publicRoutes.includes(pathname);

// Routes accessible to unauthenticated guests (B2C flow). Unlike publicRoutes,
// these auto-provision a guest session via useGuestSessionStore.ensureGuestSession()
// so the user can read/write their own OrgContractDocument rows. Patterns are
// matched as path prefixes.
export const guestAllowedRoutePatterns = [
  /^\/templates\/[^/]+\/generate$/,
  /^\/templates\/[^/]+\/review/,
];

export const isGuestAllowedRoute = (pathname: string): boolean =>
  !/^\/templates\/[^/]+\/review\/approval\/?$/.test(pathname) &&
  guestAllowedRoutePatterns.some((re) => re.test(pathname));
